// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7bbb8e83","453":"a6939a54","732":"c493b986","977":"7e03bc99"}[chunkId] + ".chunk.js";
};